var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnmuted = function SvgUnmuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33B1E3",
    d: "M5.945 47.654a41.537 41.537 0 1 0 83.075 0 41.537 41.537 0 0 0-83.075 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.115 40.222a2.32 2.32 0 0 0-3.269 0 2.32 2.32 0 0 0 0 3.27 6.93 6.93 0 0 1 0 9.805 2.32 2.32 0 0 0 0 3.269 2.32 2.32 0 0 0 3.269 0c4.51-4.517 4.51-11.834 0-16.344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.656 33.684a2.31 2.31 0 0 0-3.269 3.27c6.315 6.314 6.315 16.558 0 22.88a2.32 2.32 0 0 0 0 3.269 2.32 2.32 0 0 0 3.27 0c8.119-8.127 8.119-21.299 0-29.419M47.761 55.132V32.994c0-1.687-1.107-2.259-2.466-1.241l-9.858 7.4h-.38zM29.397 39.145h-.134a3.053 3.053 0 0 0-3.076 3.053v12.384c0 1.664 1.382 3.053 3.076 3.053h6.166l9.858 7.4c1.375 1.025 2.467.468 2.467-1.241v-1.545z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M62.656 63.111a2.31 2.31 0 0 1-3.269-3.268c6.315-6.315 6.315-16.56 0-22.882a2.32 2.32 0 0 1 0-3.268 2.32 2.32 0 0 1 3.27 0c8.119 8.127 8.119 21.299 0 29.418",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.263 57.651h.134s17.996-11.586 18.357-23.104c.019-.603 0-1.545 0-1.545 0-1.709-1.092-2.266-2.467-1.24L35.43 39.16h-6.166c-1.694 0-3.076 1.39-3.076 3.054v12.384a3.053 3.053 0 0 0 3.076 3.053"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M47.761 41.664v22.138c0 1.687-1.107 2.259-2.466 1.24l-9.858-7.398h-.38l6.352-17.99z",
    clipRule: "evenodd"
  })));
};
export default SvgUnmuted;